import { BaseGroupController } from './BaseGroupController';
import { Resources } from '@shared/localizations/Resources';
import { DataCache } from '../../../DataCache';
export class BaseAccountGroupController extends BaseGroupController {
    constructor(account, assetBalance) {
        super();
        this._account = null;
        this._assetBalance = null;
        this.Account = account;
        this.AssetBalance = assetBalance;
    }
    get Account() {
        return this._account;
    }
    set Account(value) {
        this._account = value;
        this.AssetBalance = value.assetBalanceDefault;
    }
    get AssetBalance() {
        return this._assetBalance;
    }
    set AssetBalance(value) {
        this._assetBalance = value;
    }
    isHiddenItemRow(type) {
        const itemNameKey = this.getItemNameKey(type);
        if (Resources.isHidden(itemNameKey)) {
            return true;
        }
        if (!DataCache.IsColumnAvailable(this.getItemGroupRule(), this.getItemRule(type))) {
            return true;
        }
        return false;
    }
}
